import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './router/defender'
import { globalObj } from './utils/global'
import PageHeader from '@/components/pageHeader'
import PageLoading from '@/components/pageLoding'
import NavBar from '@/components/navBar'

import "./assets/font/fonts.css";

import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipBoard from 'vue-clipboard2'
import { store } from './store'
import KeepAliveRouterView from 'keep-alive-router-view';
import appSDK from '@/utils/appSDK';

// 获取参数appName存储到本地
const urlParams = new URLSearchParams(window.location.search)
const appName = urlParams.get('appName')
if (appName) {
  localStorage.setItem('appName', appName)
}
const envType = urlParams.get('envType')
if (envType) {
  globalObj.setEnvType(envType)
}

async function getNetworkHeader() {
  const data = await appSDK.getNetworkHeader()
  if (data.accessToken) {
    globalObj.setToken(data.accessToken)
  }
  if (data.envType) {
    globalObj.setEnvType(data.envType)
  }
  if (data.appVersionCode) {
    globalObj.setAppVersion(data.appVersionCode)
  }

  localStorage.setItem('networkHeader', JSON.stringify(data))
}

// 卡尼调用
if ((globalObj.getEnvType() === 'FLUTTER_IOS' || globalObj.getEnvType() === 'FLUTTER_ANDROID') &&
  !['mrsx', 'banbei'].includes(localStorage.getItem('appName'))) {
  try {
    await getNetworkHeader()
  } catch (error) {
    console.log(error);
  }
}

Vue.use(KeepAliveRouterView);

Vue.use(Vant)
Vue.use(VueClipBoard);

// 全局组件挂载
Vue.component('PageHeader', PageHeader)
Vue.component('PageLoading', PageLoading)
Vue.component('NavBar', NavBar)

if (process.env.VUE_APP_ENV !== 'production') {
  let VConsole = require('vconsole/dist/vconsole.min.js')
  new VConsole()
} else {
  if (window) {
    window.console.log = function () { };
  }
}

Vue.prototype.$globalObj = globalObj
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
